import SkypeOptionViewState from '../data/store/schema/SkypeOptionViewState';
import getSkypeOptions from '../data/store/store';
import getUserSkypeOptions from '../utils/getUserSkypeOptions';
import { convertOwsSettingTypeToSwc, NotificationSettingType } from '../utils/swcNotificationUtils';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getFallbackValueIfNull } from 'owa-options-core';
import { action, select } from 'satcheljs/lib/legacy';
import {
    lazyCreateOrUpdateOptionsForFeature,
    OwsOptionsFeatureType,
    SkypeNotificationOptions,
} from 'owa-outlook-service-options';

export interface SaveSkypeOptionState {
    optionState: SkypeOptionViewState;
    userOptions?: SkypeNotificationOptions;
}

export default select<SaveSkypeOptionState>({
    optionState: () => getSkypeOptions(),
    userOptions: () => getUserSkypeOptions(),
})(
    action('saveSkypeOptions')(async function saveSkypeOptions(state?: SaveSkypeOptionState) {
        let { optionState, userOptions } = state;

        userOptions.skypeMessageNotification = getFallbackValueIfNull(
            optionState.imNotification as number,
            userOptions.skypeMessageNotification
        );

        userOptions.skypeCallingNotification = getFallbackValueIfNull(
            optionState.callNotification as number,
            userOptions.skypeCallingNotification
        );

        if (isFeatureEnabled('fwk-skypeSettingsMigration')) {
            // Update new settings to window.swc
            window.swc.getNotificationSettings().then(proxy => {
                proxy.setOption({
                    name: NotificationSettingType.NewMessage,
                    value: convertOwsSettingTypeToSwc(userOptions.skypeMessageNotification),
                });
                proxy.setOption({
                    name: NotificationSettingType.IncomingCall,
                    value: convertOwsSettingTypeToSwc(userOptions.skypeCallingNotification),
                });
            });
        } else {
            // Update new settings to ows'
            await lazyCreateOrUpdateOptionsForFeature.importAndExecute(
                OwsOptionsFeatureType.SkypeNotifications,
                userOptions
            );
        }
    })
);
